import React from 'react'; 
import NumberFormat from "react-number-format";

import { getBalance } from "../../../model/wallet";

import { commonErr } from "../../common/errors";
import { LoadingInline } from '../../common/loading';


class Balance extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            err: commonErr.INNIT, 
            balance: 0
        }
    }

    componentDidMount() {
        getBalance().then((resp) => {
			if (resp.data.error === commonErr.SUCCESS) {
				this.setState({
                    err: resp.data.error,
					balance: resp.data.data.balance,
				});
			} else {
				this.setState({
					err: resp.data.error,
                    balance: 0
				});
			}
		});
    }
  
    render() {
        const { err, balance } = this.state;
        return (
            <div className="balance"> 
                <h5>Số dư:</h5>
                {err === commonErr.SUCCESS ?  <h4>	
                    <NumberFormat
                        value={balance}
                        displayType={"text"}
                        thousandSeparator={" "}
                        decimalSeparator={","}
                        suffix={"đ"}
                    />
                </h4> : <LoadingInline />}
            </div>
        )

    }
}

export default Balance;
